<template>
  <transition
    mode="out-in"
    name="card-flip"
  >
    <q-card
      v-if="front"
      key="front"
      class="full-width bg-white text-black"
      @click="front = !front"
    >
      <q-card-section
        class="bg-primary text-left column justify-between"
        :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-black'"
        :style="{
          'border-bottom': `10px solid ${currentSite.secondaryColor}`,
          'min-height': $q.screen.xs ? '180px' : '140px',
          height: $q.screen.xs ? '22vh' : ''
        }"
      >
        <div
          class="col"
        >
          <div
            class="text-subtitle1"
          >
            {{ currentUser.membershipType.name }}
            <q-badge
              v-if="currentUser.membership.state !== 'active'"
              class="text-uppercase shadow-2"
              color="negative"
              :text-color="$isColorDark(currentSite.negativeColor) ? 'white' : 'black'"
              :label="currentUser.membership.state"
            />
          </div>
          <div class="text-h5 ">
            {{ currentUser.name }}
          </div>
        </div>
        <q-list
          v-if="$q.screen.xs"
          class="text-body2 q-pa-none q-mt-sm col-auto"
          dense
          separator
        >
          <q-item
            v-if="currentUser.credit > 0"
            :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-black'"
            style="padding-left: 0; padding-right: 0;"
          >
            <q-item-section>
              <q-item-label>
                {{ $t('pricing.credit') }}
              </q-item-label>
            </q-item-section>
            <q-item-section class="text-right text-bold">
              <q-item-label>
                <i18n-n
                  :value="currentUser.credit"
                  format="currency"
                  scope="global"
                />
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-if="currentUser.membershipType.hasMembershipPoints"
            class="q-pa-none"
            :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-black'"
            style="padding-left: 0; padding-right: 0;"
          >
            <q-item-section>
              <q-item-label>
                {{ currentCircuit.rewardsCurrencyName }}
              </q-item-label>
            </q-item-section>
            <q-item-section class="text-right text-bold">
              <q-item-label>
                {{ currentUser.points }}
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-if="currentUser.vouchers.data.length > 0"
            class="q-pa-none"
            :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-black'"
            style="padding-left: 0; padding-right: 0;"
          >
            <q-item-section>
              <q-item-label>
                {{ $tc('voucher.voucher', currentUser.vouchers.data.length > 1 ? 2 : 1) }}
              </q-item-label>
            </q-item-section>
            <q-item-section class="text-right text-bold">
              <q-item-label>
                {{ currentUser.vouchers.data.length }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
      <q-card-section
        :style="{ 'min-height': $q.screen.xs ? '40vh' : '240px' }"
        class="row justify-between items-center"
      >
        <div
          class="col row text-center"
          :class="$q.screen.xs ? 'items-center' : 'items-end '"
        >
          <q-list
            v-if="$q.screen.gt.xs"
            class="text-body2 q-pb-xs q-pr-md col text-black"
            dense
            separator
          >
            <q-item
              v-if="currentUser.credit > 0"
              class="text-black"
              style="padding-left: 0; padding-right: 0;"
            >
              <q-item-section>
                <q-item-label class="text-left">
                  {{ $t('pricing.credit') }}
                </q-item-label>
              </q-item-section>
              <q-item-section class="text-right text-bold">
                <q-item-label>
                  <i18n-n
                    :value="currentUser.credit"
                    format="currency"
                    scope="global"
                  />
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              class="q-pa-none text-black"
              style="padding-left: 0; padding-right: 0;"
            >
              <q-item-section>
                <q-item-label class="text-left">
                  {{ currentCircuit.rewardsCurrencyName }}
                </q-item-label>
              </q-item-section>
              <q-item-section class="text-right text-bold">
                <q-item-label>
                  {{ currentUser.points }}
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              v-if="currentUser.vouchers.data.length > 0"
              class="q-pa-none text-black"
              style="padding-left: 0; padding-right: 0;"
            >
              <q-item-section>
                <q-item-label class="text-left">
                  {{ $tc('voucher.voucher', currentUser.vouchers.data.length > 1 ? 2 : 1) }}
                </q-item-label>
              </q-item-section>
              <q-item-section class="text-right text-bold">
                <q-item-label>
                  {{ currentUser.vouchers.data.length }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
          <div
            class="column"
            :class="$q.screen.xs ? 'q-mx-auto' : undefined"
          >
            <qr-code
              class="qr-code"

              :size="$q.screen.xs ? 230 : 180"
              :style="{ 'border': $q.screen.xs ? 'solid 30px white' : 'solid 10px white' }"
              color="black"
              bg-color="white"
              :text="currentUser && currentUser.uid || null"
            />
            <div
              v-if="currentUser.card"
              class="text-center q-mx-auto"
              :class="$q.screen.xs ? undefined : 'q-mb-sm'"
            >
              {{ currentUser.card.humanUid }}
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <q-card
      v-else
      key="back"
      class="bg-primary full-width"
      :style="{
        height: $q.screen.xs ? '62vh' : '380px',
        'min-height': $q.screen.xs ? '490px' : undefined
      }"
      @click="front = !front"
    >
      <img
        class="absolute-center"
        :style="{ 'max-width': $q.screen.xs ? '50%': '30%' }"
        alt="Logomark"
        :src="membershipImageUrl"
      >
      <template v-if="currentUser">
        <div
          class="absolute-bottom q-pa-md q-mx-auto text-center"
          :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-black'"
        >
          {{ $t('membership.memberSince', { time: $d(currentUser.createdAt, 'date') }) }}
        </div>
      </template>
    </q-card>
  </transition>
</template>
<script>
import VueQRCodeComponent from 'vue-qr-generator'

export default {
  name: 'MembershipCard',
  components: {
    'qr-code': VueQRCodeComponent
  },

  data () {
    return {
      front: false
    }
  },
  context: ['currentUser'],
  configuration: ['currentSite', 'currentCircuit'],
  computed: {
    membershipImageUrl () {
      if (this.currentUser.membershipType.iconImageUrl) return this.currentUser.membershipType.iconImageUrl
      return this.$isColorDark(this.currentSite.primaryColor) ? this.currentSite.lightLogoImageUrl : this.currentSite.darkLogoImageUrl
    }
  },
  mounted () {
    this.$nextTick(this.flipCard)
  },
  methods: {
    flipCard () {
      setTimeout(() => {
        this.front = true
      }, 600)
    }
  }
}
</script>

<style scoped>
.card-flip-enter-active {
  transition: transform 0.2s ease-out;
}
.card-flip-leave-active {
  transition: transform 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.card-flip-enter {
  transform: rotateY(90deg) rotateZ(3deg);
}
.card-flip-enter-from,
.card-flip-leave-to {
  transform: rotateY(90deg) rotateZ(-5deg);
}
</style>
